import { render, staticRenderFns } from "./UiToaster.vue?vue&type=template&id=d88232ba&"
import script from "./UiToaster.vue?vue&type=script&lang=js&"
export * from "./UiToaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports